module.exports = {"name":"options","component":"Select","options":[{"key":"yes"},{"key":"yes-limited"},{"key":"no"}],"validator":"required"};